import * as Yup from "yup";

export const registerSchema = Yup.object().shape({
  name: Yup.string().required("Nome é obrigatório"),
  email: Yup.string().email("Email inválido").required("Email é obrigatório"),
  password: Yup.string()
    .required("Senha é obrigatória")
    .min(6, "Senha deve ter no mínimo 6 caracteres"),
  password_confirmation: Yup.string().required(
    "Confirmação de senha é obrigatória",
  ),
  phone_whatsapp: Yup.string(),
  plan_id: Yup.string().required("O plano é obrigatório"),
  origin_country: Yup.string(),
  accept_terms: Yup.boolean().oneOf(
    [true],
    "Você deve aceitar os Termos de Uso para continuar",
  ),
});
